<script setup>
import { useAuthStore } from '@/stores/auth'
import { resolveRoleRedirect } from '@/utils/roleRoutes'
import { useRouter } from 'vue-router'

definePage({
  meta: {
    layout: 'blank',
    public: true,
  },
})

const router = useRouter()
const authStore = useAuthStore()
const isAuthenticated = authStore.isAuthenticated
const userRole = authStore.userRole
const accessToken = authStore.accessToken
const currentUser = authStore.currentUser

const redirectToTarget = () => {
  if (!isAuthenticated.value)
    return router.replace({ name: 'login' })

  const target = resolveRoleRedirect(userRole.value || currentUser.value?.role)
  if (!target || target === '/') {
    authStore.clearAuthState()
    
    return router.replace({ name: 'login' })
  }

  return router.replace(target)
}

const ensureUserLoaded = async () => {
  if (accessToken.value && !currentUser.value) {
    try {
      await authStore.fetchAuthenticatedUser()
    }
    catch (error) {
      console.error('Unable to fetch authenticated user', error)
      authStore.clearAuthState()
    }
  }
}

onMounted(async () => {
  await ensureUserLoaded()
  await redirectToTarget()
})
</script>

<template>
  <VContainer
    class="d-flex flex-column align-center justify-center text-center h-100"
    style="min-block-size: 100vh;"
  >
    <VProgressCircular
      indeterminate
      color="primary"
      size="56"
      width="4"
    />
    <p class="mt-4 text-body-1">
      Reindirizzamento in corso...
    </p>
  </VContainer>
</template>
